import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#071019] text-gray-400 py-16 border-t border-white/5 relative overflow-hidden" data-id="element-90">
      <div className="absolute inset-0 bg-grid-pattern-small opacity-[0.02] pointer-events-none" data-id="element-91" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-92">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-93">
          {/* Brand */}
          <div data-id="element-94">
            <div className="mb-6" data-id="element-95">
              <img src="https://cdn.magicpatterns.com/uploads/qwbAJXKtFBS58G1ixVPKhL/cropped-KM-CONSULTING.png" alt="KM Consulting - Web Design & Digital Marketing" className="h-10 w-auto" data-id="element-96" />
            </div>
            <p className="mb-6 text-sm leading-relaxed text-gray-500" data-id="element-97">
              Award-winning digital agency delivering excellence in web design,
              software development, and digital marketing.
            </p>
            <div className="flex gap-4" data-id="element-98">
              {[Linkedin, Twitter, Instagram, Facebook].map((Icon, i) => <a key={i} href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/5 hover:bg-[#d8a43e] hover:text-black transition-all duration-300" data-id="element-99">
                  <Icon className="w-4 h-4" data-id="element-100" />
                </a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-101">
            <h3 className="text-white font-bold mb-6 font-mono text-sm uppercase tracking-wider" data-id="element-102">
              Quick Links
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-103">
              {[{
              name: 'About Us',
              href: '#about'
            }, {
              name: 'Our Services',
              href: '#services'
            }, {
              name: 'Portfolio',
              href: '#portfolio'
            }, {
              name: 'Blog',
              href: '#'
            }, {
              name: 'Contact',
              href: '#contact'
            }].map(item => <li key={item.name} data-id="element-104">
                  <a href={item.href} className="hover:text-[#d8a43e] transition-colors flex items-center gap-2 group" data-id="element-105">
                    <span className="w-1 h-1 bg-[#d8a43e] rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-106" />
                    {item.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-107">
            <h3 className="text-white font-bold mb-6 font-mono text-sm uppercase tracking-wider" data-id="element-108">
              Services
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-109">
              {['Web Development', 'Mobile Apps', 'UI/UX Design', 'Digital Marketing', 'Cloud Solutions'].map(item => <li key={item} data-id="element-110">
                  <a href="#services" className="hover:text-[#d8a43e] transition-colors flex items-center gap-2 group" data-id="element-111">
                    <span className="w-1 h-1 bg-[#d8a43e] rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-112" />
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-113">
            <h3 className="text-white font-bold mb-6 font-mono text-sm uppercase tracking-wider" data-id="element-114">
              Contact Us
            </h3>
            <ul className="space-y-4 text-sm" data-id="element-115">
              <li className="flex items-start gap-3" data-id="element-116">
                <MapPin className="w-5 h-5 text-[#d8a43e] shrink-0 mt-0.5" data-id="element-117" />
                <span data-id="element-118">London, United Kingdom</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-119">
                <Phone className="w-5 h-5 text-[#d8a43e] shrink-0 mt-0.5" data-id="element-120" />
                <a href="tel:+447412843259" className="hover:text-[#d8a43e] transition-colors" data-id="element-121">
                  +44 7412 843259
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-122">
                <Mail className="w-5 h-5 text-[#d8a43e] shrink-0" data-id="element-123" />
                <a href="mailto:kmconsulting.it@gmail.com" className="hover:text-[#d8a43e] transition-colors" data-id="element-124">
                  kmconsulting.it@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600" data-id="element-125">
          <p data-id="element-126">
            &copy; {new Date().getFullYear()} KM Consulting. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-127">
            <a href="#" className="hover:text-[#d8a43e] transition-colors" data-id="element-128">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-[#d8a43e] transition-colors" data-id="element-129">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}